module.exports = __webpack_public_path__ + "2fca0a810c4ed4ee692772d5b5fa634d.jpg";